import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import stickybits from 'stickybits';
import ShopFilterSearchTextbox from '../components/ShopFilterSearchTextbox.js';
import ShopCurrentFilters from '../components/ShopCurrentFilters.js';
import ShopProductListing from '../components/ShopProductListing.js';
import ShopDropdownSort from '../components/ShopDropdownSort.js';
import ShopHappyReminder from '../components/ShopHappyReminder.js';

export default class ShopContentOver767 extends Component {
  static propTypes = {
    setSearchValue: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    hasMoreToScroll: PropTypes.bool.isRequired,
    loadMoreScroll: PropTypes.func.isRequired,
    windowWidth: PropTypes.number.isRequired,
    toggleFilter: PropTypes.func.isRequired,
    products: PropTypes.array.isRequired,
    usableProducts: PropTypes.array.isRequired,
    visibleProducts: PropTypes.array.isRequired,
    productTypeInfo_DictionaryArray: PropTypes.array.isRequired,
    addItemToCart: PropTypes.func.isRequired,
    addItemToCartState: PropTypes.func.isRequired,
    cartItemCount: PropTypes.number.isRequired,
    dropdownSort: PropTypes.func.isRequired,
    selectDropdownItem: PropTypes.func.isRequired,
    toggleDropdownOpen: PropTypes.func.isRequired,
    dropdownOpen: PropTypes.bool.isRequired,
    dropdownValue: PropTypes.string.isRequired,
    scrollToTop: PropTypes.func.isRequired,
    showScrollUpButton: PropTypes.bool.isRequired,
    toggleProductCategory: PropTypes.func.isRequired,
    jarsCheck: PropTypes.func.isRequired,
    votivesCheck: PropTypes.func.isRequired,
    tartsCheck: PropTypes.func.isRequired,
    checked_jars: PropTypes.bool.isRequired,
    checked_votives: PropTypes.bool.isRequired,
    checked_tarts: PropTypes.bool.isRequired,
    filterOpen: PropTypes.bool.isRequired,
    productCategoryOpen: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    stickybits("#scrollToTopButtonID", {verticalPosition: "bottom"});
  }

  render() {

    const ShopFilterDisplay_Over767 = ( 
      <ShopFilterDisplay_Over767_Div id="shopFilterID">
            <SectionDiv>
              <h2>Product Category</h2>
              <Container>
                    <Label check >
                       <Input type="checkbox" 
                        checked={this.props.checked_jars} 
                        onClick={ this.props.jarsCheck } /> {' '}
                       <p>Jar Candles</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_votives} 
                        onClick = { this.props.votivesCheck } /> {' '}
                       <p>Votives</p>
                     </Label>
              </Container>
              <Container>
                    <Label check>
                       <Input type="checkbox" 
                        checked={this.props.checked_tarts} 
                        onClick = { this.props.tartsCheck } /> {' '}
                       <p>Tarts</p>
                     </Label>
              </Container>
            </SectionDiv>

            {this.props.showScrollUpButton ?
              <ScrollToTopImage id="scrollToTopButtonID" onClick={this.props.scrollToTop} 
              src={require("../media/scrollUpArrow2.png")}></ScrollToTopImage>
            :
            "" }

      </ShopFilterDisplay_Over767_Div>
    );

    const ShopContainer_Over767 = (
      <Container_Over767>
        {ShopFilterDisplay_Over767}
        
        <ContainerDiv_RightSide>
          <SearchFilterHeading>
            <div>
              <h1>Shop Primitives Candles</h1> 
            </div>
          </SearchFilterHeading>

          <hr />

          <ShopFilterSearchTextbox toggleFilter={this.props.toggleFilter} windowWidth={this.props.windowWidth}
            setSearchValue={this.props.setSearchValue} searchValue={this.props.searchValue} />
          <ShopCurrentFilters {...this.props} usableProductsCount={this.props.usableProducts.length} />
          <ShopDropdownSort selectDropdownItem={this.props.selectDropdownItem} toggleDropdownOpen={this.props.toggleDropdownOpen}
                            dropdownOpen={this.props.dropdownOpen} dropdownValue={this.props.dropdownValue} />
          <ShopProductListing products={this.props.products} usableProducts={this.props.usableProducts} visibleProducts={this.props.visibleProducts}
              hasMoreToScroll={this.props.hasMoreToScroll} loadMoreScroll={this.props.loadMoreScroll} 
              addItemToCart={this.props.addItemToCart} addItemToCartState={this.props.addItemToCartState} />

        </ContainerDiv_RightSide>

      </Container_Over767>
    );

    return (
      <FluidContainer className="p-0" fluid>
          <ShopHappyReminder />
          {ShopContainer_Over767}

      </FluidContainer>
    );
  }
}

const ScrollToTopImage = styled.img`
  width: 50px; 
  height: 50px;
  background: transparent;
  color: white;
  bottom: 0;
  display: block!important;
  margin: 0 auto;
  padding: 0!important;
  position: fixed;
  cursor: pointer;
  margin-left: 45px;
`;

const FluidContainer = styled(Container)`  `;
const InternalContainer = styled(Container)`  `;

const SectionDiv = styled.div`
  margin: 0 0 30px 0;
  
  // If you highlight a filter, bold the text
  .container { label { :hover { p { font-weight: bold!important; } } } }
`;

const Container_Over767 = styled(Container)`
  padding: 0 5px 0 px!important;
  width: 100%!important;
  max-width: 1400px!important;
  display: flex;
`;

const ContainerDiv_RightSide = styled.div` 
  width: 100%; 
  hr { 
    border-top: 1px solid rgba(0,0,0,.1);
    margin: 16px 0 16px 0;
  }
`;

const SearchFilterHeading = styled.div`
  div { text-align: left; }

  /*
  p:nth-of-type(1) {
    margin: 0;
    font-size: 26px!important;
    display: inline-block;
  }

  ${media.xl`  p:nth-of-type(1) { font-size: 30px!important; } `}
  ${media.xxl`  p:nth-of-type(1) { font-size: 36px!important; } `}
  */
`;

const ShopFilterDisplay_Over767_Div = styled.div`
  width: 22%;
  max-width: 180px;
  margin-right: 20px;
  
  h2 {
    text-align: left;
    font-size: 16px;
    margin: 10px 0 0px 0;
    color: #822D08!important;
    ${media.lg`  font-size: 20px; `}

  }

  .container {
    padding: 0!important;
    margin: 10px 0 0 0!important;
    width: 100%!important;
    height: 30px;

    :focus {
      outline: none;
    }

    label {
      height: 100%;
      min-width: 100%;
      width: 100%;
      line-height: 40px;
      margin: 0;
      padding: 0;
      display: inline-flex;

      input {
        width: 18px;
        height: 18px;
        margin: 11px 0 0 0;
        position: relative;
      }

      p {
        width: calc(100% - 18px);
        margin: 0 0 0 10px;
        text-align: left;
        font-size: 16px!important;

        ${media.lg`font-size: 18px!important;`}
      }

    }
  }



`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/ShopContentOver767.js